/** Better Auth's Eater realm in Nova, see apps/nova/src/auth/eater.ts. */
const BASE_PATH = "/account/api/v1/auth";
export function authError(status, code) {
    switch (code) {
        case "INVALID_EMAIL":
        case "VALIDATION_ERROR":
            return "invalidEmail";
        case "INVALID_OTP":
            return "invalidCode";
        case "OTP_EXPIRED":
        case "TOO_MANY_ATTEMPTS":
            return "expiredCode";
        case "OTP_RECENTLY_SENT":
            return "recentlySent";
        default:
            return status === 429 ? "tooManyRequests" : "unexpected";
    }
}
// Pendolino's eager bundle reaches this module, and Babel compiles it without
// regenerator-runtime, so no async/await here.
function call(path, locale, body) {
    return fetch(`${BASE_PATH}${path}`, {
        method: body ? "POST" : "GET",
        credentials: "same-origin",
        headers: {
            Accept: "application/json",
            "X-Locale": locale,
            ...(body ? { "Content-Type": "application/json" } : {}),
        },
        body: body ? JSON.stringify(body) : undefined,
    }).then((response) => response
        .json()
        .catch(() => null)
        .then((data) => {
        if (response.ok)
            return { ok: true, value: data };
        const code = typeof data === "object" && data !== null && "code" in data
            ? String(data.code)
            : undefined;
        return { ok: false, error: authError(response.status, code) };
    }), () => ({ ok: false, error: "unexpected" }));
}
export function createEaterAuthTransport(locale) {
    return {
        session: () => call("/get-session", locale),
        sendCode: (email) => call("/email-otp/send-verification-otp", locale, {
            email,
            type: "sign-in",
        }),
        signIn: (email, code) => call("/sign-in/email-otp", locale, { email, otp: code }),
        signOut: () => call("/sign-out", locale, {}),
    };
}
